(() => {
  if (customElements.get('product-qa-context')) return;

  class ProductQaContext extends HTMLElement {
    connectedCallback() {
      this.sku = this.dataset.productSku || '';
      this.main = document.getElementById('MainContent');
      this.onVariantChange = (event) => {
        const { variant, product_handle: handle } = event.detail || {};
        if (!variant || (handle && handle !== this.dataset.productHandle)) return;
        this.sku = variant.sku || '';
        this.updateModals();
      };
      this.main?.addEventListener('theme:variant:change', this.onVariantChange);
      this.onBackdropClick = (event) => {
        const overlay = event.target;
        if (!(overlay instanceof Element)) return;
        if (overlay.matches('.ac-qa-overlay-container.product-qa-image-modal')) {
          overlay.querySelector('.ac-qa-image-popup-close')?.click();
          return;
        }
        if (!overlay.matches('.ac-qa-overlay-container.product-qa-modal')) return;
        if (overlay.dataset.productQaId !== this.dataset.productId) return;
        // Let the app own dismissal and form cleanup, just as its Cancel button does.
        overlay.querySelector('.ac-qa-form-cancel')?.click();
      };
      document.body.addEventListener('click', this.onBackdropClick);
      this.observer = new MutationObserver((records) => {
        const affectsModal = records.some((record) => {
          const target = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
          return target?.closest('.ac-qa-overlay-container') || [...record.addedNodes].some((node) =>
            node.nodeType === Node.ELEMENT_NODE && (
              node.matches('.ac-qa-overlay-container') || node.querySelector('.ac-qa-overlay-container')
            )
          );
        });
        if (affectsModal) this.updateModals();
      });
      this.observer.observe(document.body, { childList: true, subtree: true, characterData: true });
      this.updateModals();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.main?.removeEventListener('theme:variant:change', this.onVariantChange);
      document.body.removeEventListener('click', this.onBackdropClick);
    }

    updateModals() {
      document.querySelectorAll('.ac-qa-overlay-container').forEach((modal) => {
        if (modal.querySelector('.ac-qa-image-popup-content')) {
          this.updateImageViewer(modal);
          return;
        }
        const badge = modal.querySelector('.ac-qa-form-product-info .ac-qa-badge-pill-info');
        if (!badge) return;
        const text = badge.textContent.trim();
        const productIdLabel = `#${this.dataset.productId}`;
        if (text !== productIdLabel && modal.dataset.productQaId !== this.dataset.productId) return;
        if (/^#\d+$/.test(text) && text !== productIdLabel) {
          return;
        }
        modal.dataset.productQaId = this.dataset.productId;
        modal.classList.add('product-qa-modal');
        const close = modal.querySelector('.ac-qa-popup-close');
        if (close && !close.getAttribute('aria-label')) close.setAttribute('aria-label', 'Close question form');

        // React renders the # prefix and ID as separate text nodes. Keep their identities intact.
        const label = this.sku ? `SKU: ${this.sku}` : 'SKU unavailable';
        const textNodes = [...badge.childNodes].filter((node) => node.nodeType === Node.TEXT_NODE);
        textNodes.forEach((node, index) => {
          const value = index === 0 ? label : '';
          if (node.data !== value) node.data = value;
        });
      });
    }

    updateImageViewer(modal) {
      modal.classList.add('product-qa-image-modal');
      // The app opens the viewer with every image of the clicked thumbnail group and
      // keeps the count in React state only, so recover it from the matching group.
      const src = modal.querySelector('.ac-qa-popup-image')?.src;
      const counts = [...document.querySelectorAll('.ac-qa-media-files')]
        .map((group) => [...group.querySelectorAll('.ac-qa-media-image')])
        .filter((images) => images.some((image) => image.src === src))
        .map((images) => images.length);
      const count = counts.length ? String(Math.max(...counts)) : '';
      if (modal.dataset.imageCount !== count) modal.dataset.imageCount = count;
    }
  }

  customElements.define('product-qa-context', ProductQaContext);
})();
